import ActivityTypeNames from '../../schema/innerSchema/ActivityTypeNames';

/**
 *  This function return the entities from the Txp Json blob.
 * filter the entities that are *not* TxpActivity type and get the entities array.
 */
export default function foundEntities(txpParsedBlob: any): any[] {
    let entities: any[];

    if (txpParsedBlob) {
        let notActivities = txpParsedBlob
            .filter(txpData => txpData.type != ActivityTypeNames.TxpActivity)
            .map(entity => entity.entities);
        entities = [].concat.apply([], notActivities);
    }

    return entities.length != 0 ? entities : null;
}
